import React from 'react';
import { Divider } from '@mui/material';
import { FieldSelect } from './FieldSelect';
import FormRow from './row';
import {
  awardsList,
  camerasList,
  employmentStatusList,
  fieldOfStudyList,
  monetizationList,
  orgSeniorityList,
  pressCoverageList,
  professionStandingList,
} from './constants';
import FieldInput from './FieldInput';
import FieldCheckbox from './FieldCheckbox';
import { useUser } from '../../../../hooks/useUser';
import { isInternal } from '../../../../utils';

export default function FormQualifications() {
  const { role } = useUser();
  
  return (
    <>
      <FormRow count={2}>
        <FieldSelect
          name="levelOfEducation"
          label="Level of education"
          options={fieldOfStudyList}
        />
        <FieldInput
          name="fieldOfStudy"
          label="Field of Study"
          placeholder="Software Engineering"
          multiline
        />
      </FormRow>

      <Divider />

      <FormRow count={2}>
        <FieldInput
          name="jobTitle"
          label="Job Title"
          placeholder="Community Manager"
        />
        <FieldInput name="company" placeholder="The Desire Company" />
      </FormRow>

      <FormRow count={2}>
        <FieldSelect
          name="employmentStatus"
          label="Employment Status"
          options={employmentStatusList}
        />
      </FormRow>

      <FormRow count={2}>
        <FieldSelect
          name="organizationSeniority"
          label="Organization Seniority"
          options={orgSeniorityList}
        />
        <FieldSelect
          name="professionalStanding"
          label="Professional Standing"
          options={professionStandingList}
        />
      </FormRow>

      <FormRow count={2}>
        <FieldSelect name="monetization" options={monetizationList} />
        <FieldSelect
          name="recognition"
          label="Awards/Recognition"
          options={awardsList}
        />
      </FormRow>

      <FormRow count={2}>
        <FieldSelect
          name="pressCoverage"
          label="Press/Media"
          options={pressCoverageList}
        />
      </FormRow>

      <FieldCheckbox name="openToPromotional" text="Open to being featured" />

      {isInternal(role) && (
        <FormRow count={2}>
          <FieldInput name="audienceReach" label="Audience Reach" />
          <FieldSelect
            name="cameraPresence"
            label="Camera Presence"
            options={camerasList}
          />
        </FormRow>
      )}
      
      <FormRow count={2}>
        <FieldInput
          name="areasOfExpertise"
          label="Areas of Expertise and Contributions"
          placeholder="Contributions"
          multiline
        />
        <FieldInput
          name="previousContent"
          label="Previous Content Links"
          placeholder="Previous content"
          multiline
        />
      </FormRow>
    </>
  );
}
